import React from 'react'
import './Footer.css'
import Git from '../../assets/github.png'
import insta from '../../assets/instagram.png'
import linkedin from '../../assets/linkedin.png'
import logo from '../../assets/logo.png'


export const Footer = () => {
  return (
    <div className="footer-container">
        <hr/>
        <div className="footer">
        <div className='social-links'>
            <img src={Git} alt="" />
            <img src={insta} alt="" />
            <img src={linkedin} alt="" />
        </div>
        <div className='logo-f'>
            <img src={logo} alt="" />
        </div>
        </div>
        <div className="blur footer-blur-1"></div>
        <div className="blur footer-blur-2"></div>
    </div>
  )
}
